import { useTranslate } from 'core/hooks/useTranslate';
import Image from 'core/modules/atoms/Image';
import ProgressBar from 'core/modules/atoms/ProgressBar';
import PropTypes from 'prop-types';
import React from 'react';
import MedalEmpty from '../icons/medals/MedalEmpty';

const GamificationBadge = ({ name, image, obtained, progress }) => {
  const { t } = useTranslate();
  return (
    <div className="gamification-badge">
      {obtained && <Image className="gamification-badge__image" src={image} alt={t('alt:Gamification badge image for name', { name: name })} />}
      {!obtained && (
        <div className="gamification-badge__no-obteiner">
          <MedalEmpty />
          <div className="gamification-badge__progress">
            <ProgressBar progress={progress} withLabel={false} />
          </div>
        </div>
      )}
      <span className="gamification-badge__name">{name}</span>
    </div>
  );
};

GamificationBadge.propTypes = {
  name: PropTypes.string,
  image: PropTypes.string,
  obtained: PropTypes.bool,
  progress: PropTypes.number,
};

export default GamificationBadge;
